export default __webpack_public_path__ + "static/media/ic_view_caret.8900440d.svg";